import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FaCheckCircle, FaAward, FaIndustry, FaHandshake, FaGlobeAsia } from "react-icons/fa";
import Information from "../Components/Information";

const About = () => {
  return (
    <div className="page-wrapper">
      {/* PAGE HEADER HERO */}
      <section className="page-banner">
        <div className="page-banner-container">
          <h1>About JK Metal &amp; Alloys</h1>
          <p>Leading Non-Ferrous Metal Manufacturer &amp; Supplier in India Since 2019</p>
        </div>
      </section>

      {/* MAIN STORY SECTION */}
      <Information
        subtitle="Trusted Name in Metallurgy"
        title="Engineering High Purity Metal Alloys & Solders"
        description="Established in 2019, JK Metal & Alloys has grown to become a benchmark manufacturer and supplier of refined Lead Ingots, pure Tin Ingots, industrial Solder Wires, Solder Sticks (63/37 ratio), Solder Paste, and high conductivity Copper products in India. Located in the industrial heart of Ahmedabad, Gujarat, we combine modern foundry technology with meticulous quality inspection."
        bullets={[
          { title: "Founded", text: "2019 in Ahmedabad, Gujarat, India." },
          { title: "Core Specialization", text: "Tin Ingots, Lead Ingots, Solder Wires, Solder Sticks (63/37), Copper Axe, Copper Flats." },
          { title: "Distribution", text: "PAN-India logistics network serving small and bulk commercial projects." }
        ]}
        imageType="tin"
        category="Company History"
      />

      {/* VISION & MISSION SECTION */}
      <section className="vision-mission-section">
        <div className="container">
          <div className="grid-2">
            <motion.div className="vision-card" whileHover={{ y: -6 }}>
              <div className="card-icon"><FaAward /></div>
              <h2>Our Mission</h2>
              <p>To manufacture and deliver non-ferrous metals and soldering alloys of uncompromised purity and consistency, empowering Indian electronics, electrical, automotive, and heavy engineering industries with dependable raw materials.</p>
            </motion.div>

            <motion.div className="vision-card" whileHover={{ y: -6 }}>
              <div className="card-icon"><FaGlobeAsia /></div>
              <h2>Our Vision</h2>
              <p>To be recognized as India’s most trusted manufacturer of Tin, Lead, and Solder solutions, expanding our pan-India footprint while adhering to sustainable metallurgical practices and ethical business standards.</p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CORE VALUES & INFRASTRUCTURE */}
      <section className="infrastructure-section">
        <div className="container">
          <div className="section-header center">
            <span className="sub-title">Manufacturing Excellence</span>
            <h2>Infrastructure &amp; Quality Control</h2>
            <p>Our state-of-the-art facility in Ahmedabad features high-efficiency smelting pots, alloy blending furnaces, and rigorous laboratory testing.</p>
          </div>

          <div className="grid-3">
            <div className="feature-box">
              <FaIndustry className="f-icon" />
              <h3>Precision Smelting</h3>
              <p>Advanced temperature-controlled melting vessels ensure precise alloy ratios and minimal dross creation.</p>
            </div>

            <div className="feature-box">
              <FaCheckCircle className="f-icon" />
              <h3>Purity Verification</h3>
              <p>Every melt is sampled for spectroscopic and chemical purity analysis before casting into ingots or drawing into wires.</p>
            </div>

            <div className="feature-box">
              <FaHandshake className="f-icon" />
              <h3>Client-Centric Customization</h3>
              <p>We supply custom ingot weights, wire diameters, and Sn/Pb ratio formulations tailored to specific client applications.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA FOOTER LINK */}
      <section className="page-cta-bar">
        <div className="container center">
          <h2>Ready to partner with JK Metal &amp; Alloys?</h2>
          <p>Get in touch with our technical team today to discuss your material requirements.</p>
          <Link to="/contact-us" className="btn-gold">Contact Us Today</Link>
        </div>
      </section>
    </div>
  );
};

export default About;